import Initial from '../../../components/Initial'
import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from '../useInitial'
import Control from './Controls'

export default function InventoryBook() {
    const { state } = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <Control />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
